export const paywallCurrencyCodes = {
  brl: "brl",
} as const;

export type PaywallCurrencyCode = keyof typeof paywallCurrencyCodes;
